// Kleine, geteilte Hilfsfunktionen für den Foodosia-Speiseplan: Preisformatierung
// und Datumsberechnung für das rollende 14-Tage-Fenster. Wird sowohl von der
// öffentlichen Speiseplan-Seite als auch vom Admin-Editor verwendet.

// Standard-Standort, bis die echte Liste vom Backend geladen ist.
export const LOCATION_ID = "loc-mannheim";
// Foodosia nutzt im Produktkatalog des Backends diesen catalogType.
export const CATALOG_TYPE = "FOODOSIA";

export function formatPrice(priceCents, currency = "EUR") {
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency,
  }).format((priceCents || 0) / 100);
}

export function isoDate(date) {
  // Lokales Datum statt UTC, damit kein Tag durch Zeitzonen verrutscht.
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function addDays(date, days) {
  const nextDate = new Date(date);
  nextDate.setDate(nextDate.getDate() + days);

  return nextDate;
}

export function startOfToday() {
  const today = new Date();

  return new Date(today.getFullYear(), today.getMonth(), today.getDate());
}

// Das rollende Fenster fängt immer heute an und zeigt die nächsten 14 Tage.
// Weil das Fenster bei jedem Aufruf neu aus dem aktuellen Datum gebaut wird,
// fallen vergangene Tage automatisch raus, ohne dass wir aufräumen müssen.
export function buildDateWindow(days = 14) {
  const start = startOfToday();

  return Array.from({ length: days }, (_, index) => isoDate(addDays(start, index)));
}
